<template>
  <div class="d-flex flex-wrap align-items-center">
    <div class="mr-auto">
      <p class="text-uppercase text-dark font-weight-bold mb-1">
        {{ title }}
      </p>
      <p class="text-dark mb-0">
        {{ description }}
      </p>
    </div>
    <div class="px-4">
      <p :class="[countColor ? 'text-' + countColor : 'text-dark', 'font-weight-bold font-size-24 mb-0']">
        {{ count }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DashboardCard',
  props: ['title', 'description', 'count', 'countColor'],
}
</script>
